import { Button, Divider, Grid, Typography } from '@mui/material'
import { Field, Form, Formik } from 'formik'
import { TextField } from 'formik-material-ui'
import { isEqual } from 'lodash'
import { memo, useCallback, useState } from 'react'
import { metodoPrograma } from '../../../components/api'
import { setError } from '../../../components/alerts'
import * as Yup from 'yup'
import CurrencyField from '../../../components/CurrencyField/CurrencyField'
import AutoComplete from '../../../components/AutoComplete/AutoComplete'
import PrimeTable from '../../../components/PrimeTable'

const retornaTerapia = (u = []) => ({
  idTerapia: u?.[0] || undefined,
  dsNome: u?.[1] || undefined,
  dsTerapia: u?.[2] || undefined,
  vlTerapia: u?.[3] || undefined,
  dtInclusao: u?.[4] || undefined,
  dtExclusao: u?.[5] || undefined,
})

const validationSchema = Yup.object({
  dsNome: Yup.string().required('Campo Obrigatório!'),
  dsTerapia: Yup.string().required('Campo Obrigatório!'),
})

const Edicao = ({ dados, voltar }) => {
  const [refresh, setRefresh] = useState(0)
  const [acCentroCusto, setAcCentroCusto] = useState(dados?.[7] || [])
  const [acPlanoConta, setAcPlanoConta] = useState(dados?.[6] || [])

  const salva = async (values) => {
    const res = await metodoPrograma('salva', {
      ...values,
      centrosCusto: acCentroCusto.flatMap((item) => item[0]),
      planosDeConta: acPlanoConta.flatMap((item) => item[0]),
    })
    if (res.status) voltar()
    else setError(res.dsErro)
  }

  const handleRemove = useCallback((info) => {
    metodoPrograma('removeFluxoAtendimentoTerapia', {
      idFluxoAtendimento: info?.[0],
      idTerapia: info?.[1],
    }).then((res) => {
      if (res.status) {
        setRefresh((prev) => prev + 1)
      }
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const salvaFluxoAtendimentoProduto = useCallback((info) => {
    metodoPrograma('salvaFluxoAtendimentoTerapia', {
      idFluxoAtendimento: info?.acFLuxoAtendimento?.[0]?.[0],
      idTerapia: dados?.[0],
    }).then((res) => {
      if (res.status) {
        setRefresh((prev) => prev + 1)
      }
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Formik
      initialValues={retornaTerapia(dados)}
      validationSchema={validationSchema}
      onSubmit={async (values, { setSubmitting }) => {
        await salva(values)
        setSubmitting(false)
      }}
    >
      {({ isSubmitting, submitForm, setFieldValue, values }) => (
        <Form style={{ width: '100%', padding: 0 }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Field
                component={TextField}
                name="dsNome"
                label="Nome"
                fullWidth
                margin="dense"
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={12}>
              <Field
                component={TextField}
                rows={4}
                multiline
                name="dsTerapia"
                label="Descrição detalhada"
                fullWidth
                margin="dense"
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={4}>
              <Field
                component={TextField}
                name="dtInclusao"
                label="Inclusão"
                fullWidth
                disabled
                margin="dense"
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={4}>
              <Field
                component={TextField}
                name="dtExclusao"
                label="Exclusão"
                fullWidth
                disabled
                margin="dense"
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={4}>
              <CurrencyField
                fullWidth
                variant="outlined"
                margin="dense"
                label="Valor"
                size="small"
                value={values?.vlTerapia}
                onChange={(v) => {
                  setFieldValue('vlTerapia', v)
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <AutoComplete
                multiple
                filterSelectedOptions
                InputLabelProps={{ shrink: true }}
                label="Plano de Conta"
                getOptionLabel={(v) =>
                  v?.[1] ? `${v?.[0]?.[0]} - ${v?.[1]}` : ''
                }
                w
                metodo="buscaPlanoConta"
                value={acPlanoConta}
                size="small"
                onChange={(_, val) => setAcPlanoConta(val)}
              />
            </Grid>
            <Grid item xs={6}>
              <AutoComplete
                multiple
                filterSelectedOptions
                InputLabelProps={{ shrink: true }}
                label="Centro de Custo"
                metodo="buscaCentroCusto"
                value={acCentroCusto}
                size="small"
                onChange={(_, val) => setAcCentroCusto(val)}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h6" gutterBottom>
                Fluxo de Atendimento
              </Typography>
            </Grid>
            <Divider />
            <Grid item xs={12}>
              <PrimeTable
                codigo="CtrlTerapia"
                action="listaFluxoAtendimentoTerapia"
                rows={10}
                parametros={{ idTerapia: dados?.[0] }}
                head={['Nome do Fluxo']}
                line={(item) => [item[2]]}
                onDelete={{ index: 1, action: handleRemove }}
                refresh={refresh}
                addButton={true}
                fastAddComponent={({ values, edit, close }) => (
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={12}>
                      <AutoComplete
                        metodo="buscaFluxoAtendimento"
                        codigo="CtrlProduto"
                        value={values?.acFLuxoAtendimento}
                        name="acFLuxoAtendimento"
                        label="Fluxo de Atendimento"
                        fullWidth
                        margin="dense"
                        variant="outlined"
                        size="small"
                        onChange={(_, val) => {
                          edit({
                            value: val,
                            field: 'acFLuxoAtendimento',
                          })
                        }}
                        textFieldProps={{
                          helperText: !values?.acFLuxoAtendimento
                            ? 'Campo Obrigatório!'
                            : '',
                          error: !values?.acFLuxoAtendimento,
                        }}
                      />
                    </Grid>
                    <Grid
                      item
                      container
                      xs={12}
                      spacing={2}
                      justifyContent="flex-end"
                    >
                      <Grid item xs={12} md={4}>
                        <Button
                          onClick={close}
                          fullWidth
                          variant="contained"
                          color="inherit"
                          style={{ margin: '5px' }}
                        >
                          Cancelar
                        </Button>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Button
                          onClick={() =>
                            !!values?.acFLuxoAtendimento &&
                            salvaFluxoAtendimentoProduto(values) &&
                            close()
                          }
                          variant="contained"
                          fullWidth
                          color="primary"
                          style={{ margin: '5px' }}
                        >
                          Salvar
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                )}
              />
            </Grid>
            <Grid
              item
              xs={12}
              style={{ display: 'flex', flexDirection: 'row-reverse' }}
            >
              <Button
                onClick={submitForm}
                disabled={isSubmitting}
                variant="contained"
                color="primary"
                style={{ margin: '5px' }}
              >
                Salvar
              </Button>
              <Button
                onClick={voltar}
                variant="contained"
                color="secondary"
                style={{ margin: '5px' }}
              >
                Cancelar
              </Button>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  )
}

export default memo(Edicao, isEqual)
